"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const theme_1 = __importDefault(require("../../../../styles/theme"));
const constants_1 = require("../../../../constants/constants");
const styles = react_native_1.StyleSheet.create({
    cardBackground: {
        backgroundColor: theme_1.default.colors.COLOR_GRAY_LIGHT,
        borderRadius: 16,
    },
    cardDeleteBackground: {
        backgroundColor: theme_1.default.colors.COLOR_GRAY_LIGHT,
        alignContent: 'center',
        alignItems: 'center',
    },
    accountNumberText: {
        flex: 1,
        fontFamily: constants_1.FONT_FAMILY,
        fontSize: 15,
        fontWeight: 'bold',
        letterSpacing: 0.25,
        color: theme_1.default.colors.COLOR_GRAY_DARK,
        textAlign: 'left',
        marginVertical: 4,
    },
});
exports.default = styles;
